module.exports = __webpack_public_path__ + "static/clockFace-4a51b2eb697197dccb105acbaa9d70f7.png";